import React, { useEffect, useState } from 'react';
import { X, Check } from 'lucide-react';

const NewSpecialModal = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Show modal after a short delay
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setIsVisible(false);
  };

  const handleBookNow = () => {
    window.open('https://www.thephytgym.com/products/gift-phytraining-4-pack', '_blank');
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/50 backdrop-blur-sm transition-opacity duration-300"
        onClick={handleClose}
      />

      {/* Modal */}
      <div className="relative bg-white rounded-2xl p-8 max-w-md w-full mx-4 transform transition-all duration-300 scale-100 animate-fade-in-up">
        <button
          onClick={handleClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <X size={24} />
        </button>

        <div className="text-center">
          <div className="inline-block bg-purple-100 text-purple-800 px-4 py-1 rounded-full text-sm font-medium mb-4">
            Limited Time Offer
          </div>
          
          <h2 className="text-2xl font-bold bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent mb-4">
            New Client Special
          </h2>
          
          <div className="mb-6">
            <div className="flex items-center justify-center gap-2 mb-2">
              <span className="text-4xl font-bold text-gray-900">$380</span>
              <span className="text-gray-500 line-through">$520</span>
            </div>
            <p className="text-gray-600 mb-4">
              4-pack training sessions for new clients
            </p>
            
            <div className="space-y-2 text-left bg-purple-50 p-4 rounded-xl">
            <div className="flex items-center gap-2">
                <Check size={18} className="text-purple-600 flex-shrink-0" />
                <span className="text-gray-700">In-person training sessions</span>
              </div>
              <div className="flex items-center gap-2">
                <Check size={18} className="text-purple-600 flex-shrink-0" />
                <span className="text-gray-700">Personalized training program</span>
              </div>
              <div className="flex items-center gap-2">
                <Check size={18} className="text-purple-600 flex-shrink-0" />
                <span className="text-gray-700">Form and technique assessment</span>
              </div>
              <div className="flex items-center gap-2">
                <Check size={18} className="text-purple-600 flex-shrink-0" />
                <span className="text-gray-700">Nutrition guidance included</span>
              </div>
              <div className="flex items-center gap-2">
                <Check size={18} className="text-purple-600 flex-shrink-0" />
                <span className="text-gray-700">Flexible scheduling</span>
              </div>
            </div>
          </div>

          <button
            onClick={handleBookNow}
            className="w-full bg-gradient-to-r from-purple-600 to-pink-600 text-white px-6 py-3 rounded-xl font-medium hover:from-purple-700 hover:to-pink-700 transition-all duration-300 transform hover:scale-105 hover:shadow-lg"
          >
            Book Your Sessions Now
          </button>
          
          <p className="text-sm text-gray-500 mt-4">
            Limited spots available. Offer valid for new clients only.
          </p>
        </div>
      </div>

      {/* Custom animations */}
      <style jsx>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fade-in-up {
          animation: fadeInUp 0.5s ease-out;
        }
      `}</style>
    </div>
  );
};

export default NewSpecialModal; 